var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonGlacier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1051.841,
    height: 1272.088,
    viewBox: "0 91.1 295.357 437.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8c3123",
    strokeWidth: 1,
    d: "M300.178 168.5v282.2l-90.1-20.6v-241z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e05243",
    strokeWidth: 1,
    d: "M328.678 182v257.6l-28.5 11.1V168.5zm-180.2-90.9l65.6 33.9v370l-65.6 33.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c3123",
    strokeWidth: 1,
    d: "M-33.322 185.1l29.2-17.4v284.6l-29.2-14.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e05243",
    strokeWidth: 1,
    d: "M33.878 176.4l52.1 12.7v241.8l-90.1 21.4V167.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c3123",
    strokeWidth: 1,
    d: "M82.078 125v370.7l66.4 33.2V91.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonGlacier);
export default __webpack_public_path__ + "static/media/amazon-glacier.d93d72598323e449578539568ec6881b.svg";
export { ForwardRef as ReactComponent };